module.exports = __webpack_public_path__ + "static/media/doc.36d0a5f4.png";